export class Colors {
  // static primary: string = '#3A00E5';
  static primary: string = "#2563EB";
  static secondary: string = "#8EA6C0";
  static white: string = "#FFFFFF";
  static black: string = "#000000";
  static borderMenu: string = "#E5E7EB";
  static inactiveTabMenu: string = "##6B7280";
  static hoverTabMenu: string = "##F9FAFB";
  static arrowSelect: string = "#61646b";
  static disabledInput: string = "#f5f5f5 ";
  static disabledInputText: string = "#666666";
  // Add more colors as needed
  static danger: string = "#DC2626";
  static success: string = "#059669";
  static borderInput: string = "#AFB1B6";
  static inputIcon: string = "#6B7280";
  static fontColorTable: string = "#6B7280";
  static backgroundColorTable: string = "#f3f4f6";
  static disabled: string = "#2563EB4D";
  static label: string = "#4b5563";
  static styledHR: string = "#E5E7EB";
  static backgroundColorModalBody: string = "#F9FaFb";
  static borderColorModalBody: string = "#D1D5DB";
  static error: string = "#EF4444";
  static errorBackground: string = "#FECACA";
  static telefoneAlertBackground: string = "#DBEAFE";
  static contribuinteNameBackground: string = "#ECECEC";
  static placeholder: string = "#6c757d";

  // Cores adicionadas para evitar erros
  static primaryDark: string = "#1e4db7"; // Versão mais escura do primary
  static text: string = "#4b5563"; // Cor padrão para textos
}
